import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * ObservacionInput - Textarea component for OT observations
 * @param {Object} props - Component props
 * @param {string} props.value - Current value of the textarea
 * @param {Function} props.onChange - Change handler receiving event
 * @returns {JSX.Element}
 */
const ObservacionInput = ({ value, onChange }) => {
    return (
        <Form.Group className="mb-3">
            <Form.Label>Observaciones</Form.Label>
            <Form.Control
                as="textarea"
                rows={3}
                value={value}
                onChange={onChange}
                placeholder="Ingrese observaciones adicionales para la orden de trabajo..."
            />
        </Form.Group>
    );
};

export default ObservacionInput;
